<template>
    <div class="dashboard-container">
      <!-- 客资管理---成单客资 -->
      <div class="app-container">
        <el-card shadow="never">
          <el-form :inline="true" class="demo-form-inline">
            <el-form-item label="订单号">
              <el-input v-model="customerId" placeholder="请输入订单号" clearable></el-input>
            </el-form-item>
            <el-form-item label="城市">
              <el-select v-model="regionName" clearable filterable placeholder="请选择城市">
                <el-option v-for="item in optionsListt" :key="item.id" :label="item.dictValue"  :value="item.dictType"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="学生姓名">
              <el-input v-model="searchStudent" placeholder="请输入学生姓名" clearable></el-input>
            </el-form-item>
            <el-form-item label="年级">
              <el-cascader clearable v-model="grade" :options="categoryList" :props="gradeListprops"></el-cascader>
            </el-form-item>
            <el-form-item label="客资类型">
              <el-select clearable filterable   id="teacher" class="select" v-model="orderStatuss" placeholder="请选择客资类型">
                <el-option v-for="item in orderTypes11" :key="item.value" :value="item.value" :label="item.label">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="费用类型">
              <el-select clearable filterable   id="teacher" class="select" v-model="orderStatusss" placeholder="请选择费用类型">
                <el-option v-for="item in orderTypes111" :key="item.value" :value="item.value" :label="item.label">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="期数">
              <el-input v-model="customerIds" placeholder="请输入期数" clearable></el-input>
            </el-form-item>
            <el-form-item label="销售">
              <el-select v-model="inputAcount1" filterable  clearable  placeholder="请选择销售" :filter-method="handleChangeName">
                <el-option v-for="item in optionsList1" :key="item.saleId" :label="item.label" :value="item.saleId"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="审批状态">
              <el-select v-model="inputAcount2" filterable  clearable  placeholder="请选择审批状态">
                <el-option v-for="item in optionsList111" :key="item.id" :label="item.label" :value="item.id"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="提交人">
              <el-select v-model="inputAcount" filterable  clearable  placeholder="请选择提交人">
                <el-option v-for="item in optionsList" :key="item.id" :label="item.realname" :value="item.id"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="完成时间" style="margin-right: 1.5rem">
              <el-date-picker value-format="yyyy-MM-dd" v-model="createTimess" type="daterange" clearable range-separator="至"  start-placeholder="开始日期" end-placeholder="结束日期"></el-date-picker>
            </el-form-item> 
            <el-form-item label="创建时间" style="margin-right: 1.5rem">
              <el-date-picker value-format="yyyy-MM-dd" v-model="createTimesss" type="daterange" clearable range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"> </el-date-picker>
            </el-form-item>
          </el-form>
  
          <div style=" text-align: end; padding: 20px;">
              <el-button @click="handleClear" icon="el-icon-close" size="small" class="btns">清除</el-button>
              <el-button type="primary" @click="handleSearch" size="small" class="btns" icon="el-icon-search">搜索</el-button>
              <el-button type="primary" icon="el-icon-download" size="small" class="btns" @click="handleDownload">导出</el-button>
          </div>
          <!-- 查询列表 -->
          <el-table :header-cell-style="{'text-align':'center', background: '#fafafa', }" :cell-style="{'text-align':'center'}" :data="list" border height="700"  v-loading="tableLoading"  element-loading-text="加载中...">
            <el-table-column :resizable="false" prop="customerId" label="订单号"></el-table-column>
            <el-table-column :resizable="false" prop="regionName" label="城市" align="center"></el-table-column>
            <el-table-column :resizable="false" prop="studentName" label="学生姓名"></el-table-column>
            <el-table-column :resizable="false" prop="gradeName" label="年级" width="200"></el-table-column>
            <el-table-column :resizable="false" prop="saleName" label="销售"> </el-table-column>
            <el-table-column :resizable="false" prop="customerType" label="客资类型">
              <template v-slot="scope">
                <span v-if="scope.row.customerType === 2">成单客资</span>
                <span v-if="scope.row.customerType === 3">退费客资</span>
              </template>
            </el-table-column>
            <el-table-column :resizable="false" prop="costType" label="费用类型">
              <template v-slot="scope">
                <span v-if="scope.row.costType === 1">全款</span>
                <span v-else-if="scope.row.costType === 2">分期</span>
                <span v-else-if="scope.row.costType === 3">续费</span>
                <span v-else-if="scope.row.costType === 4">退费</span>
                <span v-else>定金</span>
              </template>
            </el-table-column>
            <el-table-column :resizable="false" prop="periodsNumber" label=" 期数"></el-table-column>
            <el-table-column :resizable="false" prop="commitName" label="提交人"  width="120"></el-table-column>

            <el-table-column :resizable="false" prop="categoryType" label="课程类别"  width="120">
              <template v-slot="scope">
                <div   v-if="scope.row.categoryType === 1">学业课</div>
                <div   v-if="scope.row.categoryType === 2">家庭教育课</div>
              </template>
            </el-table-column>


            <el-table-column :resizable="false" prop="auditStatus" label="审批状态" width="120">
              <template v-slot="scope">
                <div style="display: flex;justify-content: space-around;color:rgb(255 54 0);" v-if="scope.row.auditStatus === 0">待审批</div>
                <div style="display: flex;justify-content: space-around;color:rgb(255 54 0);" v-if="scope.row.auditStatus === 1">驳回</div>
                <div style="display: flex;justify-content: space-around;color:rgb(23 226 31);" v-if="scope.row.auditStatus === 2">已完成</div>
              </template>
            </el-table-column>
            <el-table-column :resizable="false" prop="accomplishTime" label="完成时间" width="200"></el-table-column>
            <el-table-column :resizable="false" prop="createTime" label="创建时间" width="200"></el-table-column>
            <el-table-column header-align="center" label="操作" width="100px">
              <template v-slot="scope">
                <el-button type="text"  @click="edit(scope.row.id,scope.row)" :disabled="scope.row.auditStatus === 0 || scope.row.auditStatus === 2">编辑</el-button>
                <el-button type="text" @click="detail(scope.row.id,scope.row)">详情</el-button>
              </template>
            </el-table-column>
          </el-table>
  
          <!-- 图片弹层 -->
          <el-dialog :visible="previewDialogVisible" width="60%" class="custom-dialog">
            <img :src="previewImageUrl" style="max-width: 100%; max-height: 100%" />
          </el-dialog>
          <!--         分页 -->
          <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
            :current-page="requestParameters.currentpage" :page-size="requestParameters.pagesize"
            layout="prev, pager, next,sizes, jumper" :total="total">
          </el-pagination>
          <!--        成单编辑弹窗-->
          <!-- <order-update ref="orderUpdate" @refreshOrder="refreshOrder"  CustomerFundingType="成单"></order-update> -->
          <!--        成单客资详情页面-->
          <!-- <order-detail ref="orderDetail"></order-detail> -->
        </el-card>
      </div>
  
  
      <el-dialog :center="true" modal-append-to-body append-to-body :close-on-click-modal="false" title="绑定问卷"  :visible="showDing" :before-close="closeEditDialogs" width="33%">
  
        <div>
          <div style="margin-bottom: 10px;">绑定问卷: 测试问卷</div>
          <div>绑定提交人: 测试提交人</div>
        </div>
  
        <div  class="dialog-footer" style="text-align: end;">
          <div style="text-align: end;">
            <el-button size="small" @click="showDing = false">取 消</el-button>
            <el-button size="small" type="primary" @click="handleBinding">确 定</el-button>
          </div>
        </div>
      </el-dialog>
  
  
      <newModesCustomerFundingDetail v-if="isnewModesCustomerFundingDetail" ref="newModesCustomerFundingDetail"
       @newModesCustomerFundingDetailEvent="newModesCustomerFundingDetailEvent" 
       :typeCustomerFunding="typeCustomerFunding" isUrView="/orderCustomer/updateOrder">
      </newModesCustomerFundingDetail>
  
  
    </div>
  </template>
  <script>
  import apiBaseUrl from "../../config/api";
  import axios from "axios";
  // import CustomerUpdOrDet from './components/CustomerUpdOrDet.vue';
//   import OrderUpdate from "./OrderUpdate.vue";
//   import OrderDetail from "./OrderDetail.vue";
  import newModesCustomerFundingDetail from "./newModesCustomerFundingDetail.vue";
  export default {
    components: {
      // OrderDetail,
      // OrderUpdate, //成单编辑
      newModesCustomerFundingDetail,
    },
    data () {
      return {
        typeCustomerFunding:'',
        isnewModesCustomerFundingDetail: false,
        tableLoading: false,
        trafficSource:'',
        inputAcount:"",
        inputAcount1:"",
        inputAcount2:"",
        optionsList:[ ],
        optionsList111:[
          {
            id:0,
            label:'待审批'
          },
          {
            id:2,
            label:'已完成'
          },
          {
            id:1,
            label:'驳回'
          },
         ],
        categoryList: [],
        gradeListprops:{
         label: "gradeName",
         children: "children",
         value: "id"
        },
        grade:[],
        classTypsArr: [{ value: 1, label: '规划' }, { value: 2, label: '线下' }, { value: 3, label: '纯补课' }],
        classTypes_s: [{ value: 1, label: '在读' }, { value: 2, label: '结业' }, { value: 3, label: '停课' },{ value: 4, label: '流失' }],
        state: "",
        classType: '',
        customerId: "",//订单号
        customerIds: "",
        isRenew: "",
        regionNames: "",
        offlineStatus: "",
        onlineStatus: "",
        orderStatuss: "",//订单状态
        orderStatusss: "",
        orderStatussss:'',
        customerPaytime: "",//付款时间
        offlineStatuss: [
          {
            value: 1,
            label: '是'
          }, {
            value: 2,
            label: '否'
          },
        ],
        onlineStatuss: [
          {
            value: 1,
            label: '是'
          }, {
            value: 2,
            label: '否'
          },
        ],
        isRenews: [
          {
            value: 1,
            label: '是'
          }, {
            value: 2,
            label: '否'
          },
        ],
        orderTypes111:[
          {
            value: 1,
            label: '全款'
          },
          {
            value: 2,
            label: '分期'
          },
          {
            value: 3,
            label: '续费'
          },
          {
            value: 4,
            label: '退费'
          },
        ],
        orderTypes11:[
          {
            value: 1,
            label: '成单客资'
          },
          {
            value: 2,
            label: '退费客资'
          },
        ],
        orderTypes: [
          {
            value: 2,
            label: '待收费'
          },
          {
            value: 1,
            label: '已收费'
          }, 
          {
            value: 3,
            label: '已退费'
          },
          {
            value: 4,
            label: '已关单'
          },
       
        ],
        orderTypess: [
          {
            value: 1,
            label: '是'
          }, {
            value: 2,
            label: '否'
          },
  
        ],
        channelType:'',
        DealTypeListt: [
          {
            value: 1,
            label: "线上",
          },
          {
            value: 2,
            label: "线下",
          },
          {
            value: 3,
            label: "转介绍",
          },
  
        ],
        DealTypeList: [
          {
            value: 1,
            label: "定金",
          },
          {
            value: 2,
            label: "全额",
          },
          {
            value: 3,
            label: "分期",
          },
        ],
        teachers: [
          {
            value: 1,
            label: "小单老师",
          },
          {
            value: 2,
            label: "大单老师",
          },
          {
            value: 3,
            label: "刘老师",
          },
          {
            value: 4,
            label: "杨老师",
          },
        ], //；老师
        customerIsallpay: "",//尾款付费情况
        sources: [], //客资来源列表
  
        sources1: [
          {
            sourceId: 1,
            sourceName: "全款"
          },
          {
            sourceId: 2,
            sourceName: "分期"
          },
        ], 
        sources2: [
          {
            sourceId: 1,
            sourceName: "是"
          },
          {
            sourceId: 2,
            sourceName: "否"
          },
        ], 
  
        searchSource1: "", 
        searchSource2: "", 
  
        sourcesPeople: [], //客资来源负责人列表
        list: [],
        address: "",
        total: 0, //总条数
        url: "",
        searchWx: "", // 输入的微信号
        searchStudent: "", //输入的学生姓名
        searchTeacherId: "", //选择的老师姓名
        orderType: "", // 请选择状态
        createTimes: [], // 创建时间
        createTimess: [], // 创建时间
        createTimesss: [], // 创建时间
        paymentTime: "", // 付款时间
        searchSourcesPeople: "", //选择的来源负责人
        searchAdd: "", //选择添加方式
        selectedState: "",
        searchSource: "", //选择来源
        stateList: [],
        d: [],
        studentName: "", // 保存学生姓名的变量
        deleteCustomerId: null,
        searchKeyword: "",
        requestParameters: {
          pagesize: 10, //每页多少条
          currentpage: 1, //当前显示页码
        },
        showEdit: false, // 控制弹层显示/隐藏的变量
        srcList: [], // 预览图像的原始链接列表
        previewImageUrl: "", // 当前预览图像的链接
        previewDialogVisible: false, // 大图预览对话框是否可见
        regionName:"",
        optionsListt:[
          {dictValue:"北京", dictType:1 },
          {dictValue:"深圳", dictType:2 },
        ],

        optionsList1:[],
  
        showDing:false,
  
        optionsListtt:[
          {dictValue:"规划", dictType:1 },
          {dictValue:"线下", dictType:2 },
          {dictValue:"纯补课", dictType:3 },
        ],
        parentPhoneNumber:"",
  
  
      };
    },
    created () {
      this.getList();
      this.getDataSourse();
      this.getDataSoursePeople();
      this.getcityOptions()
    },
    mounted () {
      this.optionsList1 = JSON.parse(sessionStorage.getItem('customersaleObj1'))
      axios.get(`${ apiBaseUrl }/questionnaire/queryCreator`, { headers: { 'authorization': sessionStorage.getItem('tokenInfo') } }).then((res)=>{ this.optionsList = res.data.data })
      axios.get(`${apiBaseUrl}/grade/getGrade`,{  headers:{ 'authorization': sessionStorage.getItem('tokenInfo')  } }).then(res => {
          if (res.data.data.length > 0) {
            this.categoryList = res.data.data;
          } else {
            this.$message({ message: "获取年级列表失败",  type: "error"  });
          }
        }).catch(error => {
          console.log(error);
        });
  
    },
    methods: {

      handleChangeName(value) {
          if (value) {
            axios.post(`${apiBaseUrl}/saleWeight/getSaleList`, { saleName: value },{ headers:{ 'authorization': sessionStorage.getItem('tokenInfo') }}).then(res => {
              if (res.data.code == 200) {
                let datas = res.data.data.map(fore => {
                    fore.id = fore.telephone
                    fore.saleId = fore.saleId
                    fore.label = fore.saleName 
                    return fore
                })
                this.optionsList1 = datas
              }else{
                this.optionsList1 = JSON.parse(sessionStorage.getItem('customersaleObj1'))
              }
            })
          } else {
            this.optionsList1 = JSON.parse(sessionStorage.getItem('customersaleObj1'))
          }
      },


      getcityOptions(){
        axios.get(`${ apiBaseUrl }/dict/getDictionary/${'地域'} `,
        { headers: { 'authorization': sessionStorage.getItem('tokenInfo') }
        }).then((res)=>{ this.optionsListt = res.data.data})
      },
  
      handleBinding(){
        this.$confirm('绑定后，将更新学生相关信息，是否确认进行绑定?', '提示', {  confirmButtonText: '确定',  cancelButtonText: '取消',  type: 'warning'}).then(() => {
          this.$notify({title: '成功', message: '绑定成功~', type: 'success'  })
          // this.$notify.error({ title: '错误',message: '绑定失败~' })
          this.showDing = false
        })
      },
      closeEditDialogs(){
        this.showDing = false
      },
      details(){
        this.showDing = true
      },
      //查询列表
      getList () {
        const data = {
          pageNum: this.requestParameters.currentpage,
          pageSize: this.requestParameters.pagesize,
          customerId: this.customerId,
          regionName: this.regionName,
          studentName: this.searchStudent,
          grade: this.grade.length > 0 ? JSON.stringify(this.grade)  : '',
          saleId: this.inputAcount1,
          costType: this.orderStatusss,
          periodsNumber: this.customerIds,
          auditStatus: this.inputAcount2,
          createTimeStart: this.createTimesss.length > 0 ? this.createTimesss[0] + ' 00:00:00' :  null,
          createTimeEnd: this.createTimesss.length > 0 ? this.createTimesss[1] + ' 23:59:59' :  null,
          accomplishTimeStart: this.createTimess.length > 0 ? this.createTimess[0] + ' 00:00:00' :  null,
          accomplishTimeEnd: this.createTimess.length > 0 ? this.createTimess[1] + ' 23:59:59' :  null
        };
      


  
        this.tableLoading = true
  
        // axios.post(`${apiBaseUrl}/orderCustomer/list`, data,{  headers:{'authorization': sessionStorage.getItem('tokenInfo') }}).then((response) => {
        // axios.post(`${apiBaseUrl}/orderCustomer/listOrder`, data,{  headers:{'authorization': sessionStorage.getItem('tokenInfo') }}).then((response) => {

        axios.post(`${apiBaseUrl}/customerInformationCollectionAudit/findPage`, data,{  headers:{'authorization': sessionStorage.getItem('tokenInfo') }}).then((response) => {
          this.tableLoading = false
          if(response.data.code === -1){
              this.$message({ message: response.data.message ,type: 'error' })
              this.list = [];
              this.total = 0;
          }else{
              this.$message({ message: response.data.message ,type: 'success' })
              this.list = response.data.data.records;
              this.total = response.data.data.total; // 更新总条数
              this.requestParameters.currentpage = response.data.data.current;
              this.requestParameters.pagesize = response.data.data.size;
         }
        }).catch((error) => {
            this.tableLoading = false
            this.$message({ message: error, type: 'error' })
        })
      },
      //客资来源
      getDataSourse () {
        axios
          .get(`${apiBaseUrl}/customerinformation/sourcelist`,{
            headers:{
              'authorization': sessionStorage.getItem('tokenInfo')
            }
          }) // 请替换为你的API URL
          .then((response) => {
            this.sources = response.data.data.list;
          })
          .catch((error) => {
            console.error(error);
          });
      },
      //客资来源负责人
      getDataSoursePeople () {
        axios
          .get(`${apiBaseUrl}/customerinformation/sourcepeoplelist`,{
            headers:{
              'authorization': sessionStorage.getItem('tokenInfo')
            }
          }) // 请替换为你的API URL
          .then((response) => {
            this.sourcesPeople = response.data.data.list;
          })
          .catch((error) => {
            console.error(error);
          });
      },
      //查询状态
      handleStateChange (row) {
        const { customerId, customerState } = row; // 获取当前行的 ID 和选中的值
        axios
          .put(`${apiBaseUrl}/customerinformation/customerstateupdate`, {
            customerId: customerId,
            customerState: customerState,
          },{
            headers:{
              'authorization': sessionStorage.getItem('tokenInfo')
            }
          })
          .then((response) => {
            console.log(response);
            // 更新数据成功后，进行相应的操作
            this.stateList = response.data.data;
            if (response.data.code === 200) {
              this.$message({
                message: "客资状态保存成功",
                type: "success",
                duration: 1000,
              });
              this.getList();
            } else {
              //失败
              this.$message({
                error: "客资状态未保存",
                type: "error",
                duration: 1000,
              });
            }
          })
          .catch((error) => {
            console.log(error);
          });
      },
      //添加方式：主动/被动
      handleAddChange (row) {
        const { customerId, customerIsactive } = row; // 获取当前行的 ID 和选中的值
        axios
          .put(`${apiBaseUrl}/customerinformation/customerisactiveupdate`, {
            customerId: customerId,
            customerIsactive: customerIsactive,
          },{
            headers:{
              'authorization': sessionStorage.getItem('tokenInfo')
            }
          })
          .then((response) => {
            console.log(response);
            // 更新数据成功后，进行相应的操作
            this.addList = response.data.data;
            if (response.data.code === 200) {
              this.$message({
                message: "添加方式保存成功",
                type: "success",
                duration: 1000,
              });
              this.getList();
            } else {
              //失败
              this.$message({
                error: "添加方式保存未保存",
                type: "error",
                duration: 1000,
              });
            }
          })
          .catch((error) => {
            console.log(error);
          });
      },
      resetSuccesType (customer) {
        customer.type = 1;
      },
  
      //删除
      deleteCustomer (customerId) {
        this.$confirm("确定删除该条客资信息吗？", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(() => {
            axios
              .delete(
                `${apiBaseUrl}/customerinformation/customerdelete/${customerId}`,{
            headers:{
              'authorization': sessionStorage.getItem('tokenInfo')
            }
          }
              )
              .then((response) => {
                console.log(response);
                if (response.data.code === 200) {
                  this.$message.success("删除成功");
                  this.getList();
                } else {
                  //失败
                  this.$message.error("删除失败");
                }
              })
              .catch((error) => {
                console.log(error);
                this.$message.error("删除失败");
              });
          })
          .catch(() => {
            this.$message({
              type: "info",
              message: "已取消操作",
            });
          });
      },
      //图片预览
      handlePreview (url) {
        if (!this.srcList.includes(url)) {
          this.srcList.push(url);
        }
        this.previewImageUrl = url;
        this.previewDialogVisible = true;
      },
      //分页
      handleSizeChange (pageSize) {
        this.requestParameters.pagesize = pageSize;
        if (this.requestParameters.page === 1) {
        }
        this.getList(this.requestParameters);
      },
      // 进入某一页
      handleCurrentChange (newPage) {
        this.requestParameters.currentpage = newPage;
        this.getList();
      },
      //清除kkkk
      handleClear () {
        this.searchSource1 = "";
        this.searchSource2 = "";
        this.inputAcount = ""
        this.customerId = ""
        this.isRenew = "",
        this.state = ""
        this.offlineStatus = "",
        this.onlineStatus = "",
        this.orderType = ''
        this.orderStatuss = '',
        this.createTimes = [],
        this.createTimess = [],
        this.createTimesss = [],
        this.customerIsallpay = "";
        this.searchWx = ""; // 清除查询内容
        this.searchStatus = ""; // 清除状态
        this.searchType = ""; // 清除类型
        this.searchStudent = ""; //学生姓名
        this.searchSourcesPeople = ""; //来源负责人
        this.searchSource = ""; //选择来源
        this.searchTeacherId = ""; //老师姓名
        this.regionName = ''
        this.trafficSource = ''
        this.regionNames = ''
        this.grade = []
        this.parentPhoneNumber = ''
        this.channelType = ''

        this.customerId = ''
        this.regionName = ''
        this.searchStudent = ''
        this.grade = []
        this.orderStatuss = ''
        this.orderStatusss = ''
        this.customerIds = ''
        this.inputAcount1 = ''
        this.inputAcount2 = ''
        this.inputAcount = ''
        this.createTimess = []
        this.createTimesss = []



        this.getList(); //重新获取列表
      },
      // 搜索
      handleSearch () {
        this.requestParameters.currentpage = 1;
        this.getList();
      },
      //修改学生弹窗
      showEditDialog () {
        this.edit(); // 在打开编辑弹层时调用获取数据的方法
        this.showEdit = true;
      },
      closeEditDialog () {
        this.showEdit = false;
      },
      // 编辑表单
      saveEditForm () {
        // 保存编辑表单的逻辑
        // 将编辑后的数据提交给后端 API
        // ...
        axios
          .put(`${apiBaseUrl}/customerinformation/customerstudentupdate`, {
            customerStudent: this.studentName,
            customerId: this.customerId,
          },{
            headers:{
              'authorization': sessionStorage.getItem('tokenInfo')
            }
          })
          .then((res) => {
            if (res.data.code == 200) {
              this.$message({
                message: "修改成功",
                type: "success",
                duration: 1000,
              });
              this.showEdit = false;
              this.getList();
            } else {
              this.$message({ error: "修改失败", type: "error", duration: 1000 });
            }
          })
          .catch(
            (error) =>
              function () {
                this.$message({
                  error: "修改失败",
                  type: "error",
                  duration: 1000,
                });
              }
          );
      },
      refreshOrder () {
        this.getList();
      },
  
      newModesCustomerFundingDetailEvent(){
        this.isnewModesCustomerFundingDetail = false
        this.getList()
      },
      edit (customerId,row) {

        this.typeCustomerFunding = row.customerType === 2 ? '成单': row.customerType === 3 ? '退费' : '' 

        this.isnewModesCustomerFundingDetail = true
        this.$nextTick(() => {
          // this.$refs.orderUpdate.init(customerId);
  
          this.$refs.newModesCustomerFundingDetail.init1(customerId,1);
        });
      },
      detail (customerId,row) {

        this.typeCustomerFunding = row.customerType === 2 ? '成单': row.customerType === 3 ? '退费' : '' 

        this.isnewModesCustomerFundingDetail = true
        this.$nextTick(() => {
          // this.$refs.orderDetail.init(customerId);
  
          this.$refs.newModesCustomerFundingDetail.init1(customerId,2);
  
        });
      },
      //回显学生姓名并修改
      getStudent () {
        const data = {
          customerStudent: "",
          customerId: "",
        };
        axios
          .put(`${apiBaseUrl}/customerinformation/customerstudentupdate${data}`,{
            headers:{
              'authorization': sessionStorage.getItem('tokenInfo')
            }
          })
          .then((response) => {
            console.log(response);
          })
          .catch((error) => {
            console.log(error);
          });
      },
      //成交状态
      handleChangeType (customer) {
        this.$confirm(
          `确定修改客资成交状态吗？<span style="color: red">成交状态只可修改一次!</span>`,
          `提示`,
          {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            dangerouslyUseHTMLString: true,
            type: "warning",
          }
        )
          .then(() => {
            this.$refs.orderUpdate.orderShow(customer);
          })
          .catch(() => {
            customer.type = 1;
            this.$message({
              type: "info",
              message: "已取消操作",
            });
          });
      },
      //导出客资
      handleDownload () {
        // 定义要传递的参数
        // const params = {
        //   customerStudent: "", // 姓名
        //   customerAccount: "", //账号
        //   customerWx: this.searchWx, //要查询的微信号
        //   customerState: this.searchStatus, //选择状态
        //   customerIsactive: this.searchAdd, //选择添加方式
        //   customerType: this.searchType,
        //   type: 2,
        // };
        const params = {
          customerId: this.customerId,
          isRenew: this.isRenew,
          offlineStatus: this.offlineStatus,
          onlineStatus: this.onlineStatus,
          customerIsallpay: this.customerIsallpay,
          customerPaytime: this.customerPaytime,
          page: this.requestParameters.currentpage,
          limit: this.requestParameters.pagesize,
          studentName: this.searchStudent, //要查询的学生姓名
          teacherId: this.searchTeacherId,
          customerAccount: "",
          customerWx: this.searchWx, //要查询的微信号
          searchSource: this.searchSource, //来源
          searchSourcesPeople: this.searchSourcesPeople,
          customerType: this.searchType,
          type: 2,
          orderType: this.orderType,
          createTimes: this.createTimes,
          paymentTime: this.paymentTime,
          orderStatus: this.orderStatuss,
          account:this.inputAcount,
          state:this.state,
          // startPayTime:this.createTimess.length > 0 ? this.createTimess[0] : '',
          // endPayTime:this.createTimess.length > 0 ? this.createTimess[1] : '',
  
          startPayTime: '',
          endPayTime: '',
  
          startAllpayTime:this.createTimess.length > 0 ? this.createTimess[0] : '',
          endAllpayTime:this.createTimess.length > 0 ? this.createTimess[1] : '',
          regionName:this.regionName || localStorage.getItem('cityTepy'),
          trafficSource:this.trafficSource,
  
  
          classType: this.regionNames,
          gradeList: this.grade.lenght > 0 ? this.grade : [],
          parentPhoneNumber: this.parentPhoneNumber,
          channelType: this.channelType,
          orderStartTime:this.createTimesss.length > 0 ? this.createTimesss[0] : '',
          orderEndTime:this.createTimesss.length > 0 ? this.createTimesss[1] : '',
          customerIsallpay: this.orderStatuss,
  
  
        };
        //点击客资管理显示您好，xx老师
        let admin = window.localStorage.getItem("admin");
        if (admin != null) {
          params.customerAccount = JSON.parse(admin).adminNo;
        } else {
          let teacher = window.localStorage.getItem("teacher");
          if (teacher != null) {
            params.customerAccount = JSON.parse(teacher).adminNo;
          }
        }
  
        // params.customerAccount = this.inputAcount
        axios
          .post(
            `${apiBaseUrl}/orderCustomer/exportListOrder`,
            params,
            { responseType: "blob",
            headers:{
              'authorization': sessionStorage.getItem('tokenInfo')
            }
          }  // 设置responseType为'blob'以接收二进制数据
          )
          .then((response) => {
            const blob = new Blob([response.data], {
              type: "application/vnd.ms-excel",
            }); // 从响应中获取Blob对象
            const downloadLink = document.createElement("a"); // 创建一个下载链接
            downloadLink.href = URL.createObjectURL(blob); // 设置下载链接的URL为Blob对象的URL
            downloadLink.download = "成单客资信息.xlsx"; // 设置下载文件的文件名
            // console.log(response);
  
            downloadLink.click(); // 触发下载
          })
          .catch((error) => {
            console.log(error);
          });
      },
      //点击添加客资跳转客资收集
      addCustomer () {
        this.$router.push("/customercollect");
      },
    },
  };
  </script>
  
  <style scoped >
  
  
  .demo-form-inline {
    flex-wrap: wrap;
    display: flex;
  }
  
  /* .demo-form-inline .el-form-item {
    margin-right: 30px;
  } */
  
  .cor {
    border-radius: 5px;
    margin-top: 10px;
    background-color: #f4f4f5;
  }
  
  .num {
    padding: 10px;
    color: #ccc;
    font-size: 13px;
  }
  
  .el-icon-info {
    margin-right: 5px;
  }
  
  
  
  .page {
    position: fixed;
    bottom: 0;
    width: 80%;
  }
  
  .custom-dialog {
    overflow: auto;
  }
  
  .parent-container {
    position: relative;
  }
  
  .pagination-container {
    position: absolute;
    bottom: 10px;
  }
  
  /* 兼容移动端 */
  @media screen and (max-width: 750px) {
    .dashboard-container {
      /* overflow: auto; */
      width: 1430px;
    }
  
    /* 兼容移动端 */
    #aa>>>.el-dialog {
      width: 70% !important;
    }
  }
  .btns{
    background-color: #428BCA;
    border-color: #428BCA;
    color: #fff;
  }
  </style>
  


// WEBPACK FOOTER //
// src/MyApproval/MyApproval.vue